module.exports = __webpack_public_path__ + "img/fan_product-desc3.996ac9b7.png";